"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyFooterLink = void 0;
const react_1 = __importStar(require("react"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const LegacyFooterLink = ({ href, hrefTemplate, useCustomCallback, id, onClick, children, className }) => {
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    const { isExternal, sameOrigin } = (0, epic_games_nav_shared_1.determineExternal)(href);
    let finalHref = href;
    if (useCustomCallback) {
        const { localeHref } = (0, epic_games_nav_shared_1.getHrefWithLocale)({ href, hrefTemplate, locale });
        finalHref = localeHref;
    }
    const safe = !isExternal || sameOrigin;
    const target = safe ? '_self' : '_blank';
    const rel = safe ? '' : 'noopener noreferrer';
    const onMouseClick = (0, react_1.useCallback)((e) => {
        if (useCustomCallback) {
            if (onClick && typeof onClick === 'function') {
                onClick(e);
            }
            else {
                e.preventDefault();
                (0, epic_games_nav_shared_1.navigateWithHref)(finalHref, locale);
            }
        }
    }, [useCustomCallback, onClick, finalHref, epic_games_nav_shared_1.navigateWithHref, locale]);
    return (react_1.default.createElement("a", { id: id, onClick: onMouseClick, href: finalHref, target: target, rel: rel, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, className: className }, children));
};
exports.LegacyFooterLink = LegacyFooterLink;
//# sourceMappingURL=LegacyFooterLink.js.map